/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

/**
 * Creates a price ranking section
 *
 * <price-ranking data-price-level="ProductCtrl.productDetailData.price_level_number"></price-ranking>
 *
 */
function priceRankingDirective() {
    return {
        restrict: 'E',
        scope: {
            priceLevel: '=',
            category: '='
        },
        controller: priceRankingController,
        template: require('./priceRankingView.html')
    };
}

priceRankingController.$inject = [
    '$scope',
    'ProductService',
    'UtilService',
    'CmsContentService',
    '$filter',
];
function priceRankingController (
    $scope,
    ProductService,
    UtilService,
    CmsContentService,
    $filter
) {

    this.$onInit = function () {
        var vm = this;
        $scope.currencySign = UtilService.getSetting('currencySign');

        var priceLevelWordKey = "";

        switch ($scope.priceLevel) {
            case 1:
                priceLevelWordKey = "details_page:price_ranking_a_low_price";
                break;
            case 2:
                priceLevelWordKey = "details_page:price_ranking_an_average_price";
                break;
            case 3:
                priceLevelWordKey = "details_page:price_ranking_a_high_price";
                break;
            case 4:
                priceLevelWordKey = "details_page:price_ranking_a_premium_price";
                break;
        }

        CmsContentService.getMarketPlaceText(
            'details_page:price_ranking_sentence_1',
            {
                'category_name': $filter('lowercase')($scope.category.name),
                'price_rank': [
                    '<strong>{price_level}</strong>',
                    {
                        'price_level': priceLevelWordKey
                    }
                ]
            },
            $scope.category.id
        ).then(function (text) {
            $scope.priceRankingSentence1 = text;
        });
    }
}

module.exports = priceRankingDirective;
